// removed by extract-text-webpack-plugin
module.exports = {"ba-display":"magazines_rgRxX","hover":"magazines_7Mn0H","ba-img":"magazines_1UQ4E","ba-absolute":"magazines_1hur4","ba-title":"magazines_qY2g6","ba-subtitle":"magazines_XfPbR","ba-relative":"magazines_3pPbz","ba-mg-0":"magazines_2DmDJ"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/components/TemplateCard/styles.scss
// module id = 1046
// module chunks = 1